import { useState } from "react";
import { http } from "../lib/api";
import { useSeo } from "../lib/seo";
import { apiError } from "../context/AuthContext";
import { PageHero } from "../components/shop/Common";
import { OrderView } from "../components/shop/OrderView";

export default function TrackOrder() {
  const [f, setF] = useState({ order_number: "", email: "" });
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useSeo({ title: "Track Your Order", description: "Track your Vacation Apparel order status, production and shipping." });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      setOrder((await http.get("/orders/track", { params: f })).data);
    } catch (e2) {
      setOrder(null);
      setErr(apiError(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <PageHero eyebrow="Order tracking" title="Where's my vacation gear?" subtitle="Enter your order number & email." />
      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-14">
        <form onSubmit={submit} className="grid sm:grid-cols-[1fr_1fr_auto] gap-3" data-testid="track-order-form">
          <input required placeholder="Order # (VA-XXXXXXX)" value={f.order_number} onChange={(e) => setF({ ...f, order_number: e.target.value })} className="h-12 rounded-full border-2 border-border px-5 outline-none focus:border-turq" data-testid="track-order-number-input" />
          <input required type="email" placeholder="Email used at checkout" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="h-12 rounded-full border-2 border-border px-5 outline-none focus:border-turq" data-testid="track-order-email-input" />
          <button disabled={busy} className="h-12 px-6 rounded-full bg-sun font-bold text-navy" data-testid="track-order-submit">{busy ? "..." : "Track"}</button>
        </form>
        {err && <p className="mt-6 rounded-2xl bg-red-50 text-red-700 p-4" data-testid="track-order-error">{err}</p>}
        {order && <div className="mt-10 rounded-[28px] border border-border p-6"><OrderView o={order} /></div>}
      </section>
    </>
  );
}
